
<div v-if="getClientByid(resa.cid)" class="resaline"
  :class="[{ 'resaline-cancelled': resaCurrentState === 'CANCELLED' }, { 'print-ok': resaCurrentState !== 'TO_CONFIRM' }]"
  :id="(resaCurrentState !== 'TO_CONFIRM') ? 'printOk' : ''">
  <el-row :gutter="0" class="resaline-row">
    <el-col :span="5">
      <div class="resaline-item resaline-time">
        {{ resa.hour }}
      </div>
    </el-col>
    <el-col v-if="resa.room !== ''" class="resaline-hide"> - {{ getRoomName(resa.room) }} </el-col>
    <el-col class="resaline-hide"> - {{ getClientByid(resa.cid).civ }} </el-col>
    <el-col :span="10">
      <div class="resaline-item resaline-name">
        <div class="resaline-item-name">
          <span v-if="resa.preFix && resa.preFix !== ''">
            {{ resa.preFix.slice(0, 4) }} .
          </span>
          <span class="resaline-name-main">
            {{ maxChar(getClientByid(resa.cid).name, 13) }}
          </span>
          {{ maxChar(getClientByid(resa.cid).prenom, 14) }}
        </div>
        <div class="resaline-labels">
          <client-tag v-for="tag in [...getClientByid(resa.cid).tags].sort()" :key="tag" :idTag="tag"
            :deletable="false" :cid="resa.cid">
          </client-tag>
        </div>
        <div class="resaline-tags">
          <div v-if="resa.discount" class="resaline-tag resaline-tag-discount">
            <p>-{{ resa.discount }}%</p>
          </div>
          <div v-if="resa.allergen" class="resaline-tag" :class="'resaline-tag-allergen'"></div>
          <div class="resaline-tag" :class="'resaline-tag-' + resa.source.toLowerCase()"></div>
          <div v-if="resa.commentResa && resa.commentResa !== ''" class="resaline-tag resaline-tag-havecomment">
            <div class="resaline-tag resaline-tag-havecomment-icon"></div>
          </div>
          <div class="resaline-tag" v-if="getClientByid(resa.cid).countShow > 0">
            <div class="resaline-tag resaline-tag-countstar" v-if="getClientByid(resa.cid).countShow > 1">
              {{ getClientByid(resa.cid).countShow }}</div>
            <div class="resaline-tag resaline-tag-star">
              <div class="resaline-tag-star-icon"></div>
            </div>
          </div>
          <div class="resaline-tag" v-if="getClientByid(resa.cid).countNoShow > 0">
            <div class="resaline-tag resaline-tag-countnoshow" v-if="getClientByid(resa.cid).countNoShow > 1">
              {{ getClientByid(resa.cid).countNoShow }}</div>
            <div class="resaline-tag resaline-tag-noshow">
              <div class="resaline-tag-noshow-icon"></div>
            </div>
          </div>
          <div class="resaline-tag-cash"
            v-if="resa.type && resa.type !== undefined && resa.type !== '' && resa.amount > 0">
            <span :class="'resaline-tag-cash-' + resaPayementColorState">
              <span v-if="resa.type === 'caution'">C</span>
              <span v-else>P</span>
              : <span v-if="resa.total">{{ resa.total }}</span><span v-else>{{ Math.round((resa.amount *
                resa.nbCouvert)
                * 100) / 100 }}</span>€
            </span>
          </div>
        </div>
      </div>
    </el-col>
    <el-col class="resaline-hide"> (</el-col>
    <el-col :span="4">
      <div class="resaline-item resaline-nbCouvert">
        {{ resa.nbCouvert }}
      </div>
    </el-col>
    <el-col class="resaline-hide">)</el-col>
    <el-col class="resaline-hide" v-if="getClientByid(resa.cid).countShow > 0">
      <div style="margin-left:5px">- {{ getClientByid(resa.cid).countShow }} Show</div>
    </el-col>
    <el-col class="resaline-hide" v-if="getClientByid(resa.cid).countNoShow > 0">
      <div style="margin-left:5px">- {{ getClientByid(resa.cid).countNoShow }} NoShow</div>
    </el-col>
    <el-col class="resaline-hide" v-if="getClientByid(resa.cid).tel && getClientByid(resa.cid).tel !== ''"> -
      {{ formatPhone(getClientByid(resa.cid).tel, getClientByid(resa.cid).telPreFix) }}</el-col>
    <!-- TODO: Check resa state -->
    <el-col :span="5" class="resaline-state resaline-col resaline-col-dark"
      :class='{ "resaline-col-selected": resaSwicthSelected, "resaline-col-selected_target": getIsSwitchTarget }'>
      <div class="resaline-col-container" @click="openResa">
        <div :class="['resaline-state-new', (resa.newState) ? '' : 'resaline-state-new-hide']">new</div>
        <!-- TODO: refactor this dom line resa state -->
        <div v-if="resaCurrentState === 'TO_CONFIRM'" class="resaline-state-unvalidate">
          <div class="resaline-state-unvalidate-content">
            <div class="resaline-state-unvalidate-icon"></div>
          </div>
        </div>
        <div v-if="resaCurrentState === 'NEED_TABLE'" class="resaline-state-untabled">
          <div class="resaline-state-untabled-content">
            <div class="resaline-state-untabled-icon"></div>
          </div>
        </div>
        <div v-if="resaCurrentState === 'NO_SHOW'" class="resaline-state-noshow">
          <div class="resaline-state-noshow-content">
            <div class="resaline-state-noshow-icon"></div>
          </div>
        </div>
        <div v-if="resaCurrentState === 'CANCELLED' && this.resa.modify" class="resaline-state-cancelled-m">
          <div class="resaline-state-cancelled-m-icon"></div>
        </div>
        <div v-if="resaCurrentState === 'CANCELLED' && !this.resa.modify" class="resaline-state-cancelled">
          <div class="resaline-state-cancelled-icon"></div>
        </div>
        <div v-if="resaCurrentState === 'DONE' || (resaCurrentState === 'SHOW' && resa.tids.length === 0)"
          class="resaline-state-done">
          <div class="resaline-state-noshow-content">
            <div class="resaline-state-done-icon"></div>
          </div>
          <div class="resaline-table-id_DONE" v-if="resa.tids.length > 0">{{ resa.tids[0] }}</div>
        </div>
        <div v-if="resaCurrentState === 'CONFIRMED' || resaCurrentState === 'SHOW'" class="resaline-table"
          :class='{ "resaline-table-selected": resaSwicthSelected }'>
          <div class="resaline-table-centered">
            <div v-if="this.resa.tids.length > 1" class="resaline-table-linked">
              <div class="resaline-table-linked-icon"></div>
            </div>
            <div class="resaline-table-id"
              :class='{ "resaline-table-id_SHOW": resaSHOW, "resaline-table-id_LATE": this.resaInLate }'>{{ resaTid }}
            </div>
            <div class="resaline-table-timmer"
              :class='{ "resaline-table-timmer_LATE": this.resaInLate, "resaline-table-timmer_WARN": this.resaWarning }'
              v-if="this.resaTimer !== ''">
              {{ resaTimer }}
            </div>
          </div>
        </div>
      </div>
    </el-col>
    <el-col class="resaline-hide" v-if="getAllTablesString !== ''"> - {{ getAllTablesString }}</el-col>
    <el-col class="resaline-hide" v-if="resa.type && resa.type !== undefined && resa.type !== '' && resa.amount > 0">
      <span :class="resaPayementColorState">
        - <span v-if="resa.type === 'caution'">C</span>
        <span v-else>P</span>
        : <span v-if="resa.total">{{ resa.total }}</span><span v-else>{{ Math.round((resa.amount * resa.nbCouvert) *
          100)
          / 100 }}</span>€
      </span>
    </el-col>
    <el-col class="resaline-hide" v-if="resa.allergen">
      <div style="margin-left:10px"> - allergène / intolérance : {{ resa.allergenMessage }} </div>
    </el-col>
    <el-col class="resaline-hide" v-if="resa.commentResa && resa.commentResa !== ''">
      <div style="margin-left:10px"> -> {{ resa.commentResa }}</div>
    </el-col>
  </el-row>
  <div class="resaline-separator">
    <div class="resaline-hide" style="width:100%; border-bottom:1px dashed black; margin:10px 0"></div>
  </div>
</div>
